import { Input, List, Tabs } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { SearchSvgComponent, SoilProfileDropDownIcon, SoilProfileExpandIcon } from '../../resource/IconComponentSets';
import { GetPropertyListResponseModel } from '../../util/Request/requestType';
import IF from '../IF';
import './index.less';

interface IProps {
    dataSource: GetPropertyListResponseModel[]
    selectTargetPropertiesCallback?: (record: GetPropertyListResponseModel) => void
    selectedText?: string
    propertiesDivClick?: () => void
}

const SoilSearchProperties = (props: IProps) => {
    const {
        dataSource,
        selectTargetPropertiesCallback,
        propertiesDivClick
    } = props;

    const chemicalAll = {
        cName: '',
        category: 'Chemical',
        component: '',
        daysofValidity: 0,
        description: '',
        id: -10,
        name: 'All',
        xrdId: ''
    };

    const physicalAll = {
        cName: '',
        category: 'Physical',
        component: '',
        daysofValidity: 0,
        description: '',
        id: -20,
        name: 'All',
        xrdId: ''
    };

    const soilSearchRef = useRef(null);

    document.addEventListener('click',e => {
        if (!selectVisible || !soilSearchRef) {
            return;
        }
        if(soilSearchRef && soilSearchRef.current && !soilSearchRef.current.contains(e.target)){
            setSelectVisible(false);
        }
    });

    const [selectVisible, setSelectVisible] = useState(false);
    const [chemicalProperties, setChemicalProperties] = useState<GetPropertyListResponseModel[]>([]);
    const [physicalProperties, setPhysicalProperties] = useState<GetPropertyListResponseModel[]>([]);
    const [cacheChemicalProperties, setCacheChemicalProperties] = useState<GetPropertyListResponseModel[]>([]);
    const [cachePhysicalProperties, setCachePhysicalProperties] = useState<GetPropertyListResponseModel[]>([]);

    const tabChange = (e: string) => {
        console.log('e:=', e);
    };

    const selectTargetProperty = (record: GetPropertyListResponseModel) => {
        selectOpenOrClose(false);
        selectTargetPropertiesCallback(record);
    };

    const selectOpenOrClose = (visible: boolean) => {
        setSelectVisible(visible);
        propertiesDivClick && propertiesDivClick();
    };

    const filterByInputValue = (e) => {
        if (e.target.value.length === 0) {
            setChemicalProperties(cacheChemicalProperties);
            setPhysicalProperties(cachePhysicalProperties);
            return;
        }

        const resultChecmicalArr = [];
        cacheChemicalProperties.forEach((item) => {
            const name = item.name;
            const value = e.target.value;
            const reg = new RegExp(value, 'i');
            const result = name.match(reg);
            if (result) {
                resultChecmicalArr.push(item);
            }
        });

        const resultPhysicalArr = [];
        cachePhysicalProperties.map((item) => {
            const name = item.name;
            const value = e.target.value;
            const reg = new RegExp(value, 'i');
            const result = name.match(reg);
            if (result) {
                resultPhysicalArr.push(item);
            }
        });
        setChemicalProperties(resultChecmicalArr);
        setPhysicalProperties(resultPhysicalArr);
    };

    useEffect(() => {
        const chemicalDataSource = [];
        const physicalDataSource = [];
        dataSource.forEach((item) => {
            if (item.category == 'Chemical') {
                chemicalDataSource.push(item);
                if (chemicalAll.xrdId.length > 0) {
                    chemicalAll.xrdId += `,${item.id}`;
                } else {
                    chemicalAll.xrdId += `${item.id}`;
                }
            }
            if (item.category == 'Physical') {
                physicalDataSource.push(item);
                if (physicalAll.xrdId.length > 0) {
                    physicalAll.xrdId += `,${item.id}`;
                } else {
                    physicalAll.xrdId += `${item.id}`;
                }
            }
        });
        const includeAllChemicalTag = [chemicalAll, ...chemicalDataSource];
        const includeAllPhysicalTag = [physicalAll, ...physicalDataSource];
        setChemicalProperties(includeAllChemicalTag);
        setPhysicalProperties(includeAllPhysicalTag);
        setCacheChemicalProperties(includeAllChemicalTag);
        setCachePhysicalProperties(includeAllPhysicalTag);
    }, [dataSource]);

    const items = [
        { label: 'Chemical', key: '1', children: (
            <List
                className='soil-search-properties-list'
                dataSource={chemicalProperties}
                renderItem={(record) => (
                    <div key={record.id} onClick={() => selectTargetProperty(record)} className='item-property-div'>
                        <span>{record.name}</span>
                    </div>
                )}
            />) }, // remember to pass the key prop
        { label: 'Physical', key: '2', children: (
            <List
                className='soil-search-properties-list'
                dataSource={physicalProperties}
                renderItem={(record) => (
                    <div key={record.id} onClick={() => selectTargetProperty(record)} className='item-property-div'>
                        <span>{record.name}</span>
                    </div>)}
            />
        )}
    ];

    return (
        <div className='soil-search-property-container' onClick={() => selectOpenOrClose(true)}>
            {/*No need display the searchedText,because when delete the SearchText,the SearchText still exist in span*/}
            <span ref={soilSearchRef} className='select-area-span'>{'Select Property'}</span>
            <IF show={selectVisible}>
                <div className='select-filter-container'>
                    <div className='input-container' style={{ position: 'relative' }} >
                        <Input style={{ paddingLeft:'25px' }}
                            className='input-owner-style'
                            placeholder='Search...'
                            onChange={filterByInputValue}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        />
                        <SearchSvgComponent style={{ position: 'absolute',left:'5%',top:'34%' }} />
                    </div>
                    <div className='selected-properties-container'>
                        <Tabs
                            items={items}
                            style={{ maxHeight: '190px'}}
                            onChange={tabChange}
                        />
                    </div>
                </div>
            </IF>
            <IF show={!selectVisible}>
                <SoilProfileDropDownIcon onClick={() => selectOpenOrClose(true)} className='drop-down-icon' />
            </IF>
        </div>
    );
};

export default SoilSearchProperties;